import { render, staticRenderFns } from "./typeFilter.vue?vue&type=template&id=37cc4a1e&"
import script from "./typeFilter.vue?vue&type=script&lang=js&"
export * from "./typeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports